<template>
  <div v-if="imageLoaded" class="image-container">
    <img :src="imageUrl" alt="Loaded Image" />
    <div class="text-overlay">{{ text }}</div>
  </div>
</template>

<script>
import api from "@/request/api";
 
export default {
	  name: "Img",
  data() {
    return {
      imageUrl: '', // 初始为空字符串
      text: 'Hello, World!', // 要显示的文字
      imageLoaded: false, // 控制图片是否加载和显示的条件
    };
  },
  methods: {
    loadImage() {
      // 假设这是从服务器获取图片URL的异步操作
      api
        .getRewardInfo()
        .then(response => {
			    if (response.status === 200) {
					
          this.imageUrl = response.data.url; // 假设返回的数据中包含图片URL
          this.imageLoaded = true; // 设置条件为true，显示图片和文字
		  
		
		  this.text=response.data.text; 
		  }
        })
        .catch(error => {
          console.error('Error loading image:', error);
        });
    }
  },
  mounted() {
    this.loadImage(); // 组件挂载后加载图片
  }
};
</script>

<style scoped>
.image-container {
    position: fixed;
    position: fixed;
    top: 188px;
    /* left: -8px; */
    /* width: 100px; */
    /* height: 100px; */
    /* display: inline-block; */
    z-index: 9999;
    float: inherit
}

.image-container img{
	width: 100%;
	/* top:-10px; */
}
 
.text-overlay {
  position: absolute;
  top: 74%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white; /* 或其他颜色 */
  font-size: 24px; /* 根据需要调整 */
  text-align: center;
  pointer-events: none; /* 防止文字遮挡图片的点击事件 */
}
</style>